import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSEO } from '../hooks/useSEO';
import { shouldShowGetBridge } from '../lib/inAppBrowser';
import { HeroSection } from '../components/home/HeroSection';
import { StatsStrip } from '../components/home/StatsStrip';
import { MatchedYesShowcase } from '../components/home/MatchedYesShowcase';
import { FeaturesGrid } from '../components/home/FeaturesGrid';
import { DareLevels } from '../components/home/DareLevels';
import { StoriesCarousel } from '../components/home/StoriesCarousel';
import { QuizCTA } from '../components/home/QuizCTA';
import { Testimonials } from '../components/home/Testimonials';
import { BlogTeaser } from '../components/home/BlogTeaser';
import { FinalCTA } from '../components/home/FinalCTA';

export function Home() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (shouldShowGetBridge()) {
      navigate(`/get${location.search}`, { replace: true });
    }
  }, [navigate, location.search]);

  useSEO({
    title: 'LuvLust — Couples App for Dares, Quizzes & Intimate Games',
    description: 'Discover your partner\'s fantasies with intimate quizzes, spicy dares, and roleplay stories. 500k+ couples playing. Download free.',
    keywords: 'couples app, couple game, relationship app, couple quiz, dares for couples, date night ideas',
  });

  return (
    <>
      <HeroSection />
      <StatsStrip />
      <FeaturesGrid />
      <MatchedYesShowcase />
      <DareLevels />
      <StoriesCarousel />
      <QuizCTA />
      <Testimonials />
      <BlogTeaser />
      <FinalCTA />
    </>
  );
}
